import { render, staticRenderFns } from "./tr-weekpicker.vue?vue&type=template&id=f53d408a&"
import script from "./tr-weekpicker.vue?vue&type=script&lang=js&"
export * from "./tr-weekpicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports